import React, { useMemo } from 'react';
import { Table } from 'antd';

import { getColumns } from '../utils/getColumns';
import { RecommendationsProps } from '../service/recommendations.interface';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../../crm/interfaces/common.interface';

export const RecommendationsTable = (
    props: CommonTableProps<RecommendationsProps, CommonFiltersProps>
) => {
    const { filters, updateFilters, source, loading } = props;

    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Рекомендаций'
            ),
        [filters, updateFilters, source?.total]
    );

    return (
        <Table
            loading={loading}
            style={{
                minWidth: '100%',
            }}
            pagination={pagination}
            dataSource={source?.items || []}
            rowKey={record => record.id}
            columns={getColumns()}
        />
    );
};
